import { Chart } from "primereact/chart";
import React, { useEffect, useState } from "react";
import { getEstimatedDonation } from "../../../apis/CycleApi";
import { allDonationsByCyleId, getAmountofCurrentCycle } from "../../../apis/DonationApi";
import "./estimatedDonationsChart.scss";
const EstimatedDonationsChart = () => {
  const [estimatedDonation, setEstimatedDonation] = useState();
  const [estimatedAmount, setEstimatedAmount] = useState();
  const [currentCycleDate, setCurrentCycleDate] = useState();
  const [currentCycleAmount, setCurrentCycleAmount] = useState();
  const [loading, setLoading] = useState(true);

  const currentCycleData = () => {
    getAmountofCurrentCycle().then((res) => {
      if (res.status === 200) {
        setCurrentCycleAmount(res.data);
        // setLoading(false);
      }
    });
    allDonationsByCyleId().then((res) => {
      if (res.status === 200) {
        var sDate = res.data[0];
        setCurrentCycleDate(sDate?.cycleid?.startDate);
        // setLoading(false);
      }
    });
  };

const getEstimatedDonationData = () => {
  const apiValue = estimatedAmount;
  const perWeekValue = apiValue / 8;
  let test = 0;
  const arr = [];

  for (let i = 1; i <= 8; i++) {
    test += perWeekValue;
    arr.push(test);
  }

  const weekNo = currentweekno();
  const arr1 = [];

  if (Array.isArray(currentCycleAmount)) {
    // Assume currentCycleAmount is already an array
    arr1.push(...currentCycleAmount);
  } else {
    // If it's a single number, generate weekly values
    const perWeekCurrent = currentCycleAmount / weekNo;
    for (let i = 1; i <= 8; i++) {
      arr1.push(perWeekCurrent * i);
    }
  }

  setEstimatedDonation({
    labels: [
      "1st Week", "2nd", "3rd", "4th", "5th", "6th", "7th", "8th"
    ],
    datasets: [
      {
        label: "Estimated Donation",
        data: arr,
        backgroundColor: "#42A5F5",
      },
      {
        label: "Current Cycle Donation",
        data: arr1,
        backgroundColor: "#00D4C6",
      },
    ],
  });
};


  const currentweekno = () => {
    new Date().getFullYear();
    new Date().getDay();
    var startDate = new Date(currentCycleDate);
    var currentDate = new Date();
    var days = Math.floor((currentDate - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);
    return weekNumber;
  };

  const EstAmount = () => {
    getEstimatedDonation().then((res) => {
      if (res.status === 200) {
        setEstimatedAmount(res.data);
        setLoading(false);
      }
    });
  };



  useEffect(() => {
    EstAmount();
    // getEstimatedDonationData();
    currentCycleData();
    // currentweekno();
  }, []);

  useEffect(() => {
    // EstAmount();
    if (estimatedAmount || currentCycleAmount || currentCycleDate) {
      getEstimatedDonationData();
    }
  }, [estimatedAmount, currentCycleAmount, currentCycleDate]);


 const getLightTheme = () => {
  let basicOptions = {
    maintainAspectRatio: false,
    aspectRatio: 0.7,
    plugins: {
      legend: {
        labels: {
          color: "#495057",
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#495057",
        },
        grid: {
          color: "#ebedef",
          drawBorder: false,
        },
      },
      y: {
        ticks: {
          color: "#495057",
        },
        grid: {
          color: "#ebedef",
          drawBorder: false,
        },
      },
    },
  };

  return {
    basicOptions,
  };
};

const { basicOptions } = getLightTheme();

return (
  <div className="layout-main widther">
    <div className="card-1">
      {/* <span className="block text-500 font-medium mb-1">
        Estimated Donations
      </span> */}
      <Chart
        type="bar" 
        data={estimatedDonation}
        options={basicOptions}
        loading={loading}
      />
    </div>
  </div>
);
};

export default EstimatedDonationsChart;
